import {LoginEmail} from "@/models/auth";
import {apiConfig} from "@/store";


const shouldRefreshSession = (): boolean => {
    const session = apiConfig.session;
    const xToken = apiConfig.headers.xToken;
    const {exp, role} = session;
    const currentTime: number = Date.now();
    const expSession = exp ? exp * 1000 : null;
    const bufferTime = 5 * 60 * 1000 + 15000; // 5 минут + 15 сек
    const day = 24 * 60 * 60 * 1000; // 24 часа
    const expired = expSession ? (expSession + day - bufferTime) : 0;
    return !(xToken && expSession && role && expired > currentTime);
}

export const setSession = (): Promise<void>  => {
    if (!shouldRefreshSession()) return Promise.resolve();
    return apiConfig.request({
        endpoint: apiConfig.endpoints?.startSession,
        isSetSession: true
    })
}
export const loginEmail = (data: LoginEmail) => apiConfig.request({
    endpoint: apiConfig.endpoints?.loginEmail,
    data: data,
    isSetSession: true
});